export default __webpack_public_path__ + "static/media/magicTool.a38375e7.svg";